export default __webpack_public_path__ + "static/media/73e74e9652b28cb326014f50ebc8dcea.3f49a5a3.svg";